import { IAppState } from '../../AppModulesWrapper';

import { EMicrofrontendHostName } from '../types/reducers/microfrontend';

export const selectMicrofrontendHostName = (state: IAppState): EMicrofrontendHostName | null => {
  return state.microfrontend.hostName;
};
